import { useCollabManager } from '@databases/utils/hooks/useCollabManager';
import { getMediaClient, MediaClient } from '@databases/utils/media-client';
import { useMemo } from 'react';

export function useMediaClient(contentId: string | undefined): MediaClient | undefined {
  const collabManager = useCollabManager(contentId ?? null);

  return useMemo(() => {
    if (collabManager) {
      return getMediaClient(collabManager);
    } else {
      return undefined;
    }
  }, [collabManager]);
}
